.overlay {
	position: fixed;
	inset: 0;
	background: rgba(15, 23, 42, 0.35);
	display: grid;
	place-items: start center;
	padding: 2rem 0.75rem 0.75rem;
	z-index: 100;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.18s ease;
}
.show {
	opacity: 1;
	pointer-events: auto;
}

.panel {
	width: 100%;
	max-width: 720px;
	max-height: 85vh;
	background: #fff;
	border-radius: 0.75rem;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
	display: flex;
	flex-direction: column;
	overflow: hidden;
	transform: translateY(8px);
	transition:
		transform 0.18s ease,
		opacity 0.18s ease;
	opacity: 0;
}
.panelIn {
	transform: translateY(0);
	opacity: 1;
}

.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.75rem;
	padding: 0.3rem 1rem;
	border-bottom: 1px solid #e5e7eb;
}
.titles {
	flex: 1 1 auto;
	min-width: 0;
}
.title {
	margin: 0;
	font-size: 1rem;
	line-height: 1.75rem;
	color: #111827;
}
.close {
	border: 1px solid #e5e7eb;
	background: #fff;
	color: #111827;
	width: 36px;
	height: 36px;
	border-radius: 0.5rem;
	cursor: pointer;
	display: grid;
	place-items: center;
	transition: background 0.15s ease;
	&:hover {
		background: #f3f4f6;
	}
}

.summary {
	padding: 0;
	background: transparent;
	border-bottom: none;
}

.content {
	padding: 1rem;
	overflow: auto;
	min-height: 0;

	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #a8a8a8;
		border-radius: 15px;
	}
}

.footer {
	background: #fff;
	border-top: 1px solid #e5e7eb;
	padding: 0.9rem 1rem;

	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex-wrap: wrap;

	.footerLeft {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		flex-wrap: wrap;

		margin-right: auto;
	}

	.footerRight {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		flex-wrap: wrap;
	}
}

.footer .footerLeft > * + *,
.footer .footerRight > * + * {
	margin-left: 0.5rem;
}

.sizeSm {
	max-width: 420px;
}
.sizeMd {
	max-width: 640px;
}
.sizeLg {
	max-width: 840px;
}
.sizeXl {
	max-width: 1040px;
}
.sizeXxl {
	max-width: 1280px;
}
.sizeFull {
	max-width: 100%;
	height: 90vh;
}

@media (max-width: 768px) {
	.panel {
		max-width: 100%;
		height: auto;
		max-height: calc(100dvh - 1.5rem);
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
	.sizeFull {
		height: 92svh;
	}
}

@media (max-width: 640px) {
	.overlay {
		place-items: start center;
		padding: 0.75rem;
	}

	.panel {
		max-width: 100%;
		max-height: calc(100dvh - 1.5rem);
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.content {
		overflow: auto;
		min-height: 0;
		padding-bottom: 0.5rem;
	}

	.footer {
		background: #fff;
		border-top: 1px solid #e5e7eb;
		padding: 0.9rem 1rem;
	}
}
